import React from "react";
import { observer, inject } from "mobx-react";
import Container from "reactstrap/lib/Container";
import { pipe } from "Utils";
import AddressPopupHOC from "HOC/AddressPopupHOC";
import AddressSearchHomeContainerB from "Containers/AddressSearchHomeContainerB";
import { SearchAddressWrapper } from "ComponentsUI/SearchAddress";

const AddressSearchContainer = (props) => {
	let text = props.ApplicationModel.text;
	let windowSizes = props.ApplicationModel.windowSizeModel.windowSizes;
	let seoBlock = props.seoBlock;
	return (
		<SearchAddressWrapper
			text={text}
			background={props.background}
			windowSizes={windowSizes}
			hideTitle={props.hideTitle}
			seoBlock={seoBlock}
		>
			<Container>
				<AddressPopupHOC>
					<AddressSearchHomeContainerB
						sendGAWhenFulled={!!props.sendGAWhenFulled}
						withQuiz={true}
						isOrderToHome={props.isOrdersToHome}
						is404={props.is404}
						flat={true}
					/>
				</AddressPopupHOC>
			</Container>
		</SearchAddressWrapper>
	);
};

export default pipe(observer, inject("ApplicationModel"))(AddressSearchContainer);
